<template>
  <v-card-text>
    <v-container>
      <v-col class="justify-center">
        <h1
          style="
            text-align: center;
            font-weight: 800;
            font-size: 28px;
            line-height: 36px;
            letter-spacing: 0.04em;
            font-family: Mont;
            font-style: normal;
          "
        >
          Sign In Now!
        </h1>
        <v-form ref="form" style="margin-top: 40px" lazy-validation>
          <v-alert v-if="errorMessage" color="red" type="error">{{
            errorMessage
          }}</v-alert>

          <v-text-field
            maxlength="50"
            flat
            type="email"
            outlined
            v-model.trim="email"
            placeholder="Email"
            required
            :error-messages="
              $v.email.$errors.length ? $v.email.$errors[0].$message : ''
            "
            style="margin-bottom: 22px"
            @keyup="onEnter"
          ></v-text-field>

          <v-text-field
            id="password"
            flat
            outlined
            v-model="password"
            :error-messages="
              $v.password.$errors.length ? $v.password.$errors[0].$message : ''
            "
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show1 ? 'text' : 'password'"
            name="input-10-1"
            placeholder="Password"
            @click:append="show1 = !show1"
            style="margin-bottom: 22px"
            @keypress="
              (ev) => {
                ev.code == 'Enter' && login();
              }
            "
          ></v-text-field>

          <!-- captcha -->
          <v-row v-if="isDevModeIPProtection && !bypasscaptcha" class="align-center" style="margin: 0;">
            <v-col cols="8" style="padding: 0 12px 0 0;">
              <img :src="captchaImage" alt="CAPTCHA" class="captcha-image" style="width: 100%; height: auto;" />
            </v-col>
            <v-col cols="4" class="d-flex justify-start" style="padding: 0;">
              <v-btn
                icon
                small
                color="white"
                title="Refresh CAPTCHA"
                @click="refetchCaptcha"
                class="captcha-refresh-btn"
              >
                <v-icon>mdi-reload</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" style="padding: 12px 0 0 0;">
              <v-text-field
                v-model="captchaInput"
                flat
                outlined
                placeholder="Enter CAPTCHA"
                :error-messages="$v.captchaInput && $v.captchaInput.$errors && $v.captchaInput.$errors.length ? $v.captchaInput.$errors[0].$message : ''"
                style="margin-bottom: 22px"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-btn
            id="submit"
            block
            height="50"
            depressed
            color="secondary"
            class="mr-4 mt-7 text-capitalize font-weight-bold"
            @click="login"
          >
            {{ loading ? "Sign In..." : "Sign In" }}
          </v-btn>
          <br />
        </v-form>
      </v-col>
    </v-container>

    <dialogIP v-if="ipError" v-model="ipError" :errmsg="ipErrorMsg" />

    <dialogsuccess :email="email" v-model="success" @close="closeDialog" />
    <dialogfailloginVue
      :message="dialogfailloginMessage"
      v-model="dialogfaillogin"
      @reset="doReset"
      @close="
        () => {
          dialogfaillogin = false;
        }
      "
    />
    <dialogReset v-model="opendialogreset" />
    <dialogForgot
      v-model="opendialogforgot"
      @success="
        () => {
          opendialogreset = true;
          dialogfaillogin = false;
        }
      "
      @error="
        (message) => {
          opendialogfailedforgot = true;
          dialogfailForgotMessage = message;
        }
      "
    />
    <dialogFailedReset
      v-model="opendialogfailedforgot"
      :message="dialogfailForgotMessage"
    />
    <DialogSystemUpgrade v-model="showSystemUpgradeDialog" />
  </v-card-text>
</template>
<script>
import Dialogsuccess from "@/modules/emailverification/dialogsuccess";
import { onMounted, ref, watch } from "@vue/composition-api";
import { useState } from "vuex-composition-helpers";
import {
  useNamespacedActions,
  useNamespacedState,
  useNamespacedGetters,
} from "vuex-composition-helpers";
import { HOMEPAGE } from "../homepage/namespace";
import { email, password, show1 } from "../homepage/emailpass";
import { VERIFYEMAIL } from "./namespace";
import useVuelidate from "@vuelidate/core";
import { required, email as Email, helpers } from "@vuelidate/validators";
import dialogfailloginVue from "../homepage/dialogfaillogin";
import localstorage from "@/lib/localstorage";
import dialogIP from "../homepage/dialogIP.vue";
import dialogReset from "../homepage/dialogReset.vue";
import dialogFailedReset from "../homepage/dialogFailedReset.vue";
import dialogForgot from "../homepage/dialogForgot.vue";
import DialogSystemUpgrade from "../homepage/dialogsystemupgrade.vue";

// const isDevModeIPProtection = process.env.VUE_APP_DEV_MODE === 'fase-1.3'
const isDevModeIPProtection = true;

export default {
  components: {
    Dialogsuccess,
    dialogfailloginVue,
    dialogIP,
    dialogReset,
    dialogFailedReset,
    dialogForgot,
    DialogSystemUpgrade,
  },
  data() {
    return {
      errorMessage: undefined,
      isDevModeIPProtection,
    };
  },
  methods: {
    closeDialog() {
      this.success = false;
    },
    onEnter(e) {
      this.email = this.email.toLowerCase();
    },
  },
  setup(props, context) {
    const success = ref(false);
    const { token } = context.root.$route.query;
    const { topbarloading } = useState(["topbarloading"]);
    const { verifyemail } = useNamespacedActions(VERIFYEMAIL, ["verifyemail"]);
    const { fetchCaptcha, verifyCaptcha } = useNamespacedActions(HOMEPAGE, ["fetchCaptcha", "verifyCaptcha"]);
    const { captchaImage } = useNamespacedGetters(HOMEPAGE, ["captchaImage"]);
    
    let bypasscaptcha = false;
    if (localStorage.getItem("captcha") && atob(localStorage.getItem("captcha")) == process.env.VUE_APP_BYPASS_CAPTCHA) {
      bypasscaptcha = true;
    }

    onMounted(async () => {
      if (token) {
        topbarloading.value.start();
        verifyemail(token).then(() => {
          success.value = true;
          topbarloading.value.done();
        });
      }
      if (isDevModeIPProtection && !bypasscaptcha) {
        await fetchCaptcha();
      }
    });
    const dialogfailloginMessage = ref("");
    const dialogfailForgotMessage = ref("");
    const opendialogforgot = ref(false);
    const opendialogfailedforgot = ref(false);
    const showSystemUpgradeDialog = ref(false);
    const $auth = context.root.$auth;
    const loading = ref(false);
    const dialogfaillogin = ref(false);
    const { login: Login } = useNamespacedActions(HOMEPAGE, ["login"]);
    const { user } = useNamespacedState("ROLEPERMISSION", ["user"]);
    const captchaInput = ref("");

    const refetchCaptcha = async () => {
      try {
        await fetchCaptcha();
        captchaInput.value = "";
      } catch (error) {
        console.error("Error refetching CAPTCHA:", error);
      }
    };

    const additionalRules = isDevModeIPProtection && !bypasscaptcha
      ? {
          captchaInput: { 
            required: helpers.withMessage("Captcha couldn't be empty.", (val) => {
              return bypasscaptcha ? true : !!val;
            }),
          },
        }
      : {};

    const additionalValidation = isDevModeIPProtection && !bypasscaptcha
      ? {
          captchaInput,
        }
      : {};

    const doReset = async () => {
      opendialogforgot.value = true;
    };

    const doFailedReset = async () => {
      opendialogfailedforgot.value = true;
    };

    const $v = useVuelidate(
      {
        email: { required, Email },
        password: { required },
        ...additionalRules,
      },
      {
        email,
        password,
        ...additionalValidation,
      }
    );

    const ipError = ref(false);
    const ipErrorMsg = ref("");

    const login = async () => {
      $v.value.$touch();
      if ($v.value.$errors.length) return;
      loading.value = true;

      try {
        let verify;
        if (isDevModeIPProtection && !bypasscaptcha) {
          verify = await verifyCaptcha({
            captcha: captchaInput.value,
          });

          if (verify?.data?.status == "failed") {
            captchaInput.value = "";
            loading.value = false;
            dialogfailloginMessage.value = "Invalid CAPTCHA. Please try again.";
            dialogfaillogin.value = true;
            refetchCaptcha();
            return;
          }
        }

        const data = await Login({
        email: email.value,
        password: password.value,
          captcha: bypasscaptcha ? localStorage.getItem("captcha") : captchaInput.value,
        });

          if (data.need_validate) {
            localstorage.setItem("need_validate", true);
            ipError.value = true;

            const errmsg = [
              "IP address",
              "device",
              "IP address and the device",
            ];

            ipErrorMsg.value = errmsg[data.validate_reason - 1];
          }

          if (data.need_create_organization) {
            return context.root.$router.push("/create-organization");
          }

          if (data.need_create_project && data.role !== "Superadmin") {
            return context.root.$router.push("/create-new-project");
          }

          context.root.$VueEvent.emit("after-check-login", data);

          context.root.$VueEvent.listen("after-user-permission-fetch", () => {
            if (context.root.$route.path !== "/") {
              context.root.$router.replace("/");
            }
          });
      } catch (e) {
        if (e.code === "AUTH-004") {
          showSystemUpgradeDialog.value = true;
        } else {
          dialogfailloginMessage.value = e.data;
          dialogfaillogin.value = true;
        }
        if (isDevModeIPProtection && !bypasscaptcha) {
          refetchCaptcha();
        }
      } finally {
          loading.value = false;
      }
    };
    return {
      ipErrorMsg,
      ipError,
      $v,
      user,
      login,
      success,
      doReset,
      doFailedReset,
      dialogfailForgotMessage,
      dialogfailloginMessage,
      opendialogfailedforgot,
      opendialogforgot,
      opendialogreset: ref(false),
      email,
      password,
      show1,
      loading,
      dialogfaillogin,
      showSystemUpgradeDialog,
      captchaImage,
      captchaInput,
      refetchCaptcha,
      bypasscaptcha,
    };
  },
  watch: {
    dialogfaillogin(newVal) {
      if (newVal && isDevModeIPProtection && !bypasscaptcha) {
        refetchCaptcha();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.v-card__text {
  ::v-deep .v-btn__content {
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: 0.02em;
  }
}

.v-input {
  ::v-deep .v-input__slot {
    margin-bottom: 0;
  }
}

.captcha-image {
  width: 100%;
  height: auto;
}
</style>
